import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fac32c5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "first_title" }
const _hoisted_2 = { class: "second_title" }
const _hoisted_3 = { class: "characteristic" }
const _hoisted_4 = {
  key: 0,
  class: "characteristic_item"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "immediately" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "specail" }, "仕入れを加速する", -1))
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 会員機能、")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 今すぐログインで体験！ ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 구매를 가속화하는 멤버십 기능.")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 바로 로그인 체험! ")
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_17 = /*#__PURE__*/_createTextVNode("위탁 발송을 통한 효율성 향상! ")
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" Accelerated membership features for procurement, Log in now to experience it! Through proxy shipping to achieve efficiency improvements! ")


import { isKO, isEN, isJA } from '@/store';
import { t } from '@/plugins/i18n'

export default /*#__PURE__*/_defineComponent({
  props: ['h5'],
  setup(__props) {



const characteristics = [
  {
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/login/login_icon_1.png',
    title: '【专属的商品提案】',
    content: '通过提出差异化产品及未在阿里巴巴平台上架的商品，实现摆脱低价竞争的战略。'
  }, {
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/login/login_icon_2.png',
    title: '【品牌代理销售权及折扣价采购】',
    content: '付费会员专享！通过品牌代理销售或独家销售实现与竞争对手的差异化，获得品牌代理销售权及折扣价采购。'
  }, {
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/login/login_icon_3.png',
    title: '【OEM/ODM服务及产品选项】',
    content: '丰富的定制选项和OEM服务，助力您打造自有品牌。'
  }, {
    icon: 'https://static-s.theckb.com/BusinessMarket/Client/login/login_icon_4.png',
    title: '【通过dropshipping实现效率化】',
    content: '日本のECサイトと連携し、在庫なしで自動発注・発送が可能！'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["login_left", { 'h5': __props.h5 }])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('品牌成长的全方位支持')), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('THE CKB（直航）付费会员')), 1),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(characteristics, (item, idx) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
          (idx != 3 || (idx == 3 && _unref(isJA)()))
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("img", {
                  class: "icon",
                  src: item.icon,
                  alt: ""
                }, null, 8, _hoisted_5),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)(item.title)), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)(item.content)), 1)
              ]))
            : _createCommentVNode("", true)
        ], 64))
      }), 64))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_unref(isJA)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_9,
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isKO)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _hoisted_13,
            _hoisted_14,
            _hoisted_15,
            _hoisted_16,
            _hoisted_17
          ], 64))
        : _createCommentVNode("", true),
      (_unref(isEN)())
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _hoisted_18
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})